// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { getCredential, getCommonError } from '../../store/selectors';
import * as loginActions from '../../store/actions';
import * as basketActions from '../../../basket/store/actions';
import { Button, Input } from '../../../../components';
import styles from './styles';

class Form extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    onLogin: PropTypes.func,
    changeField: PropTypes.func,
    toCheckout: PropTypes.bool,
    credential: PropTypes.object,
    commonError: PropTypes.string,
    resetCommonError: PropTypes.func,
    tokenError: PropTypes.bool,
    basketReset: PropTypes.func,
    message: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    onLogin: null,
    credential: {},
    changeField: null,
    toCheckout: false,
    commonError: null,
    resetCommonError: () => { },
    tokenError: () => { },
    basketReset: () => { },
    message: null,
  };

  onSingIn = (e) => {
    const { toCheckout } = this.props;
    e.preventDefault();
    const cartId = localStorage.getItem('CartID');
    const data = {
      ...this.props.credential,
    };
    if (cartId) data.cartId = cartId;
    this.props.onLogin(data, toCheckout, false);
    return false;
  };

  onChangeInput = (value, name) => {
    this.props.changeField(value, name);
  };

  componentWillUnmount() {
    this.props.resetCommonError();
  }

  componentDidMount() {
    if (this.props.tokenError) {
      this.props.basketReset();
    }
  }

  render() {
    const {
      classes,
      toCheckout,
      commonError,
      message,
    } = this.props;
    return (
      <div className={classes.mainContainer}>
        <form action="#" onSubmit={this.onSingIn} className={'needs-validation'} noValidate >
          <div className={classNames('form-group', classes.form)}>
            {message && <h6 className={classes.message}>{message}</h6>}
            <Input
              label={'Email'}
              name={'email'}
              inputType={'email'}
              value={this.props.credential.email}
              onChange={this.onChangeInput}
              labelStyle={classes.labelStyle}
              width={300}
              autoComplete="email"
            />
            <Input
              label={'Password'}
              inputType={'password'}
              name={'password'}
              value={this.props.credential.password}
              onChange={this.onChangeInput}
              labelStyle={classes.labelStyle}
              width={300}
              autoComplete="current-password"
            />
            <Link to={'/forgot-password'} className={classes.forgotPassword}>Forgot password?</Link>
            <h6 className={classes.commonError}>{commonError}</h6>
            <Button
              text={'login'}
              onPress={this.onSingIn}
              style={classNames(classes.buttonStyle, classes.submitButton)}
              type={'submit'}
            />
          </div>
        </form>
        <Link
          className={classes.link}
          to={{ pathname: '/register', state: { checkout: toCheckout } }}
        >
          <Button
            text={'register new account'}
            style={classNames(classes.buttonStyle, classes.registerButton)}
          />
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credential: getCredential(state),
    commonError: getCommonError(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogin: (data, toCheckout, isNewCustomer) => dispatch(loginActions.requestLogin(data, toCheckout, isNewCustomer)),
    changeField: (value, name) => dispatch(loginActions.changeField(value, name)),
    resetCommonError: () => dispatch(loginActions.resetCommonError()),
    basketReset: () => dispatch(basketActions.basketReset()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Form));
